import React from 'react';
import { Header, Segment } from 'semantic-ui-react';
import ThirdPartyAppsTable from '../../components/ThirdPartyAppsTable';

const ThirdPartyApps = () => (
  <>
    <Segment>
      <Header as='h3'>第三方应用管理</Header>
      <ThirdPartyAppsTable />
    </Segment>
  </>
);

export default ThirdPartyApps;